export enum BriefingStatusApiEnum {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    SENT = 'SENT',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    SCHEDULED = 'SCHEDULED',
    EXPIRED = 'EXPIRED'
}
